import React, { useState } from "react";
import Navbar from "../../Common/Navbar/navbar";
import Footer from "../Footer";
import SideMenu from "../SideMenu/sideMenu";
import PropTypes from "prop-types";
const Layout = (props) => {
  const [sidenavActive, setSidenavActive] = useState(false);
  return (
    <div className="app-container">
      <div className="row m-0">
        <div className="col-12 ">
          <Navbar setSidenavActive={setSidenavActive} />
        </div>
      </div>
      <div className="content-container">
        <div>
          <SideMenu sidenavActive={sidenavActive} history={props.history} />
        </div>
        <div
          style={sidenavActive ? { marginLeft: 0 } : null}
          className="route-container"
        >
          {props.children}
        </div>
        <div>{<Footer />}</div>
      </div>
    </div>
  );
};
Layout.propTypes = {
  history: PropTypes.any,
  children: PropTypes.any
}
export default Layout;
